import Login from "components/features/Login";
import { useState } from "react";
import secureLocalStorage from "react-secure-storage";
import Main from "./Main";

function App() {
  const userDetails = secureLocalStorage.getItem("un");
  const [isLoggedIn, setIsLoggedIn] = useState(!!userDetails);

  return isLoggedIn ? <Main /> : <Login isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />;
}

export default App;
